import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import InfoTooltip from './info-tooltip';
import Icon from './icon';

class SelectInput extends Component {
  static displayName = 'SelectInput';
  static propTypes = {
    validation: PropTypes.shape({
      message: PropTypes.string,
      status: PropTypes.oneOf(['error', 'success', 'none'])
    }),
    title: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.bool,
    success: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        text: PropTypes.string.isRequired
      })
    ),
    value: PropTypes.object,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['large', 'regular', 'small']),
    autoFocus: PropTypes.bool,
    gapTopSize: PropTypes.oneOf(['sm', 'none'])
  };
  static defaultProps = {
    options: [],
    size: 'large',
    autoFocus: false
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      inputFocus: false
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      setTimeout(() => this.focus(), 500);
    }
  }

  componentDidUpdate() {
    if (this.refs.infoTooltip) {
      if (this.state.inputFocus) {
        this.refs.infoTooltip.show();
      } else {
        this.refs.infoTooltip.hide();
      }
    }
  }

  focus() {
    findDOMNode(this.refs.selectField).focus();
  }

  onBlur() {
    this.setState({ inputFocus: false });
  }

  stopTooltipInfoClick(event) {
    event.stopPropagation();
  }

  onChange(event) {
    var value = event.target.value;
    var selected = this.props.options.filter(option => option.value === value)[0];
    this.props.onChange(selected);
  }

  onFocus() {
    var { value } = this.props;
    if (value && value.value === -1) {
      var firstOption = this.props.options[0];
      this.props.onChange(firstOption);
    }
    this.setState({ inputFocus: true });
  }
  renderValidation() {
    var error = this.props.error;
    var success = this.props.success;
    var message = error || success;
    var messageComponent = null;
    if (message) {
      if (error) {
        messageComponent = (
          <div className="icon-wrap" ref="infoTooltipAlign">
            <Icon className="icon" name="validation-circle-error" />
            <InfoTooltip
              ref="infoTooltip"
              alignElement={() => this.refs.infoTooltipAlign}
              direction="top"
            >
              <span className="text">{message}</span>
            </InfoTooltip>
          </div>
        );
      } else {
        messageComponent = (
          <div className="icon-wrap" ref="infoTooltipAlign">
            <Icon className="icon" name="validation-circle-success" />
          </div>
        );
      }
    }
    return messageComponent;
  }

  renderSelectedText() {
    const { value } = this.props;

    if (!value) {
      return null;
    }

    const { title, description, text } = value;

    if (title && description) {
      return (
        <span className="selected-field-text">
          <span className="selected-field-title">{title}</span>
          {description}
        </span>
      );
    } else if (text) {
      return text;
    } else {
      return null;
    }
  }
  render() {
    var {
      title,
      disabled,
      description,
      error,
      success,
      className,
      size,
      value,
      gapTopSize
    } = this.props;
    var inputClassNames = classnames('select-field', className, {
      ['--gap-top-size-' + gapTopSize]: gapTopSize || null,
      error: error ? 'error' : '',
      success: success ? 'success' : ''
    });
    var messageComponent = this.renderValidation();

    title = title || <div className="field-title">{title}</div>;
    description = description ? <div className="field-description">{description}</div> : null;
    return (
      <div className={inputClassNames}>
        {title}
        {description}
        <div className={'select-box-' + size} style={{ position: 'relative' }}>
          <span className="selected-field">{this.renderSelectedText()}</span>
          {messageComponent}
          <select
            ref="selectField"
            name="platform"
            onChange={this.onChange.bind(this)}
            onBlur={this.onBlur.bind(this)}
            disabled={disabled}
            onFocus={this.onFocus.bind(this)}
            value={value && value.value}
          >
            {this.props.options.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.text}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default SelectInput;
